import { cloneDeep, isNumber } from "lodash"
import { generateLegend, getChartObject, legendIDGenerator } from "../../common"
import {
  ANALYTIC_RESULT_LINE,
  CRITICAL_COLOR,
  CAUTIONARY_COLOR
} from "../lineChart"
import { getCircuitAndCompressorInstances } from "../../applicability"

// Critical limits (red): lr = Lower Red, ur = Upper Red
// Cautionary limits (yellow): ly = Lower Yellow, uy = Upper Yellow
export const criticalLimits = ["lr", "ur"]
export const cautionaryLimits = ["ly", "uy"]

function parseDecimalOrNull(value) {
  if (
    typeof value === "string" &&
    /^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(value.trim())
  ) {
    return parseFloat(value)
  }
  return null
}
export const limitList = ["lr", "ly", "ur", "uy"]
export const analyticsResultsProcessor = (
  analyticResults: any = {},
  chartInfo: any = {},
  oldLegends: any,
  selectedEquipmentProperties: any = []
) => {
  const { circuitInstances, compressorInstances } =
    getCircuitAndCompressorInstances(selectedEquipmentProperties)

  const isSingleInstance =
    circuitInstances?.length === 1 && compressorInstances?.length === 1
  const resultKeys = Object.keys(analyticResults?.results || {})
  const equipKeys = Object.keys(analyticResults?.index || {})
  const analyticKeys = Object.keys(analyticResults?.at || {})
  const analyticLegends: any = {}
  if (analyticKeys?.length) {
    analyticKeys?.forEach((analyticKey) => {
      const analyticPos = analyticResults?.at?.[analyticKey]
      const axis: any = chartInfo?.axisConfig?.find((obj) =>
        getChartObject(obj, analyticKey, "", true, isSingleInstance)
      )

      const analyticKeysConfig = Object.keys(
        axis?.analyticsResultsList || {}
      )?.map((key) => key?.split(" "))
      let instance = ""
      let configKey: any = analyticKeysConfig?.find((keyArray) => {
        const replaceIndex = keyArray?.findIndex((key: any) => key === "#$")
        const filteredKeyArray = keyArray?.filter((key: any) => key !== "#$")
        const propKeySplitted = analyticKey?.split(" ")
        instance = propKeySplitted?.[replaceIndex]
        if (
          Array.isArray(propKeySplitted) &&
          replaceIndex > 0 &&
          replaceIndex < propKeySplitted?.length &&
          !isSingleInstance
        ) {
          propKeySplitted?.splice(replaceIndex, 1)
        }
        return propKeySplitted?.every(
          (key: any, index) => key === filteredKeyArray?.[index]
        )
      })
      configKey = configKey?.join(" ")
      const analytic = axis?.analyticsResultsList?.[configKey]
      if (analytic) {
        Object.keys(analytic || {})?.forEach((subAnalyticKey) => {
          const subAnalytic = analytic?.[subAnalyticKey]
          const isLimit = limitList?.includes(subAnalyticKey?.toLowerCase())
          const legendName = subAnalytic?.displayName?.replace("#$", instance)

          equipKeys?.forEach((eID: any) => {
            const ePos = analyticResults?.index?.[eID]

            const legendId = legendIDGenerator(eID, legendName)
            let legendObj: any

            // Determine color based on limit type (critical = red, cautionary = yellow)
            const subAnalyticKeyLower = subAnalyticKey?.toLowerCase()
            const isCriticalLimit =
              criticalLimits?.includes(subAnalyticKeyLower)
            const isCautionaryLimit =
              cautionaryLimits?.includes(subAnalyticKeyLower)
            const limitColor = isCriticalLimit
              ? CRITICAL_COLOR
              : isCautionaryLimit
              ? CAUTIONARY_COLOR
              : undefined

            if (isLimit) {
              if (analyticLegends?.[legendId]) {
                legendObj = analyticLegends?.[legendId]
                // Apply color to existing legend if it's a limit type
                if (limitColor && !legendObj.color) {
                  legendObj.color = limitColor
                }
              } else {
                legendObj = generateLegend({
                  legendId,
                  name: legendName,
                  axisName: axis?.axisName,
                  symbol: axis?.symbol,
                  type: ANALYTIC_RESULT_LINE,
                  value: {},
                  oldLegends,
                  additionalAttributes: limitColor
                    ? { color: limitColor }
                    : undefined
                })
              }
            } else {
              legendObj = generateLegend({
                legendId,
                name: legendName,
                axisName: axis?.axisName,
                symbol: axis?.symbol,
                type: ANALYTIC_RESULT_LINE,
                value: {},
                oldLegends
              })
            }

            resultKeys?.forEach((date) => {
              const dataObj =
                analyticResults?.results?.[date]?.[ePos]?.[analyticPos]
              const value = parseDecimalOrNull(dataObj?.[subAnalyticKey])
              if (isLimit) {
                if (!isNumber(legendObj?.value?.[`${date}T00:00:00`])) {
                  legendObj.value[`${date}T00:00:00`] = value
                }
              } else {
                legendObj.value[`${date}T00:00:00`] = value
              }
            })

            if (!analyticLegends?.[legendId]) {
              analyticLegends[legendId] = legendObj
            }
          })
        })
      }
    })
  }
  return analyticLegends
}
